// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import GlampingPage from "../pages/Glamping/Glamping";
const __wvcRoutePaths = ["/GlampingPage", "/glamping"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about", "aboutpage", "blog", "blogpage", "contact", "contactpage", "gallery", "gallerypage", "glamping", "glampingpage", "home", "homepage", "post", "pricing", "pricingpage", "weddings", "weddingspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<GlampingPage />} />
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<GlampingPage />} />
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
